export default __webpack_public_path__ + "static/media/LY.94db7777.svg";